import router from '@/router/index';
import { appSectionService } from '@/services/app-section.service';
import { clearPushTokenSyncState } from '@/services/push.service';
import store from '@/store/index';
import { Capacitor, CapacitorHttp } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { isPlatform } from '@ionic/vue';
import axios from 'axios';
import { getAppGlobalContext } from '@/utils/app-global-context';
import { isNetworkConnected } from '@/utils/network-status';

async function revokeCurrentServerSession(): Promise<void> {
  const token =
    localStorage.getItem('jhi-authenticationToken') ||
    sessionStorage.getItem('jhi-authenticationToken') ||
    (await Preferences.get({ key: 'jwt' })).value;
  if (!token?.trim()) return;
  try {
    if (isPlatform('ios') || isPlatform('android')) {
      await CapacitorHttp.request({
        method: 'POST',
        url: `${process.env.VUE_APP_API_URL}api/account/logout`,
        headers: { Authorization: `Bearer ${token}` },
        readTimeout: 5000,
      });
    } else {
      await axios.post('api/account/logout', {}, { headers: { Authorization: `Bearer ${token}` } });
    }
  } catch {
    /* локальный выход выполним в любом случае */
  }
}

/** Сброс клиентской сессии; гостя при сети ведём на витрину, без сети — на экран входа. */
export async function clearClientSessionAndRedirectGuest(
  sessionExpired = true,
  redirect: 'auto' | 'login' = 'auto'
): Promise<void> {
  if (!sessionExpired) {
    await revokeCurrentServerSession();
  }
  localStorage.removeItem('jhi-authenticationToken');
  sessionStorage.removeItem('jhi-authenticationToken');
  localStorage.removeItem('cached-authorities');
  await appSectionService.clearCache();
  void Preferences.remove({ key: 'jwt' }).then(() => Preferences.remove({ key: 'cached-authorities' }));

  store.commit('logout');
  clearPushTokenSyncState();

  const g = getAppGlobalContext();
  const current = router.currentRoute.value;
  const name = current.name as string | undefined;
  if (name === 'Login' || name === 'Showcase') {
    return;
  }

  const online = await isNetworkConnected();
  if (online && g) {
    g.offlineMode = false;
  }

  const query = sessionExpired ? { sessionExpired: '1' } : undefined;
  if (redirect === 'login') {
    await router.replace({ path: '/login', query });
    return;
  }
  if (online) {
    await router.replace({ path: '/showcase', query });
  } else {
    await router.replace({ path: '/login', query });
  }
}
